import React from 'react'
import AdmBookAccessionReport from '../../components/AdminTabs/AdminBookAccessionReport/AdmBookAccessionReport'

const BookAccessionReport = () => {
  return (
    <div>
        <AdmBookAccessionReport/>
    </div>
  )
}

export default BookAccessionReport